module.exports = __webpack_public_path__ + "img/search.c60a285d.svg";